import React from "react";

export function CloseIcon({
  size = 24,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M14.1215 15.5354L12 13.4138L9.8783 15.5355L8.46409 14.1213L10.5858 11.9996L8.46469 9.87857L9.87891 8.46436L12 10.5854L14.1209 8.46445L15.5352 9.87866L13.4142 11.9996L15.5358 14.1212L14.1215 15.5354Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Close2Icon({
  size = 12,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M10.795 0.5L6 5.295L1.205 0.5L0.5 1.205L5.295 6L0.5 10.795L1.205 11.5L6 6.705L10.795 11.5L11.5 10.795L6.705 6L11.5 1.205L10.795 0.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
